import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'pictureFormat';

export class PictureFormat extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
